import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {EmployeeEditHistoryEntry, EmployeeEditHistoryResource} from 'resteasytox';
import {EmployeeType} from '../../settings-employees/settings-employees.component';
import {EditableEmployeeEditHistoryEntry} from '../settings-employee-edit-history.component';
import * as moment from 'moment';
import * as _ from 'lodash';
import {EmployeesEditHistoryCacheService} from '../../../core/employee-edit-history-cache.service';

interface EmployeeEditHistoryResponse {
	success: boolean;
	message?: string;
	entry?: EmployeeEditHistoryEntry;
}

@Component({
	selector: 'tt-employee-edit-history-add-modal',
	templateUrl: 'employee-edit-history-add-modal.component.html',
	styleUrls: ['employee-edit-history-add-modal.component.scss']
})
export class EmployeeEditHistoryAddModalComponent implements OnInit {
	@Input() employeeId: number;
	@Input() display: boolean;
	@Output() displayChange: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() entryAdded: EventEmitter<void> = new EventEmitter<void>();

	public EMPLOYEE_TYPE: any = EmployeeType;
	public newEntry: EditableEmployeeEditHistoryEntry = this.initNewEntry();
	public loader: boolean = false;

	constructor(
		@Inject('EmployeeEditHistoryResource') private employeeEditHistoryResource: EmployeeEditHistoryResource,
		private employeesEditHistoryCacheService: EmployeesEditHistoryCacheService
	) {

	}

	ngOnInit(): void {
	}

	public onClose(): void {
		this.newEntry = this.initNewEntry();
		this.displayChange.emit(false);
		this.hideLoader();
	}

	public onSuccess(): void {
		this.entryAdded.emit();
		this.cancel();
	}

	public cancel(): void {
		this.onClose();
	}

	public save(): void {
		this.showLoader();
		const entry: EditableEmployeeEditHistoryEntry = this.newEntry;
		if (entry.workStartTimeFormatted) {
			if (!this.isValid12HoursTime(entry.workStartTimeFormatted)) {
				alert('Work Start Time is not valid');
				return;
			}
		}
		if (entry.workEndTimeFormatted) {
			if (!this.isValid12HoursTime(entry.workEndTimeFormatted)) {
				alert('Work End Time is not valid');
				return;
			}
		}

		const data: EmployeeEditHistoryEntry = _.assign(entry, {
			employeeId: this.employeeId,
			startDate: entry.startDateFormatted,
			endDate: entry.endDateFormatted,
			workStartTime: (!entry.workStartTimeFormatted) ? undefined : moment.duration(this.convert12TimeTo24(entry.workStartTimeFormatted)).asMilliseconds(),
			workEndTime: (!entry.workEndTimeFormatted) ? undefined : moment.duration(this.convert12TimeTo24(entry.workEndTimeFormatted)).asMilliseconds()
		});
		const updatedEntry: EmployeeEditHistoryEntry = new EmployeeEditHistoryEntry().initFromData(data);

		this.employeeEditHistoryResource.put(updatedEntry)
			.then((res: EmployeeEditHistoryResponse) => {
				this.employeesEditHistoryCacheService.updateData()
					.subscribe(() => {
						if (res.success) {
							this.onSuccess();
						} else {
							alert(res.message);
						}
						this.hideLoader();
					});
			})
			.catch((err: any) => {
				console.error(err);
				alert(err);
				this.hideLoader();
			});
	}

	public showLoader(): void {
		this.loader = true;
	}

	public hideLoader(): void {
		this.loader = false;
	}

	public formatEmployeeTypeToReadable(value: EmployeeType): string {
		if (value === null || value === undefined) { return; }
		value = parseInt(value.toString(), 10);
		if (value === EmployeeType.DAILY_1099) {
			return '1099 Daily';
		} else if (value === EmployeeType.HOURLY_1099) {
			return '1099 Hourly';
		} else if (value === EmployeeType.DAILY_W2) {
			return 'W-2 Daily';
		} else if (value === EmployeeType.HOURLY_W2) {
			return 'W-2 Hourly';
		}
	}

	private initNewEntry(): EditableEmployeeEditHistoryEntry  {
		const newEntry: EditableEmployeeEditHistoryEntry = new EmployeeEditHistoryEntry() as EditableEmployeeEditHistoryEntry;

		newEntry['workStartTimeFormatted'] = '8:30 am';
		newEntry['workEndTimeFormatted'] = '5:30 pm';

		return newEntry;
	}

	private isValid12HoursTime(time: string): boolean {
		const blankRegex: RegExp =  /\s+/gmi;
		const isValidTimeRegex: RegExp = /[0-9]{1,2}:[0-9]{1,2}(am|pm)?$/gmi;
		time = time.replace(blankRegex, '').toLowerCase();
		return isValidTimeRegex.test(time);
	}

	private convert12TimeTo24(time: string): string {
		const blankRegex: RegExp =  /\s+/gmi;
		time = time.replace(blankRegex, '').toLowerCase();

		const postfix: string = (time.search('pm') !== -1) ? 'pm' : 'am';
		time = time.replace('am', '').replace('pm', '');
		if (postfix === 'am') {
			return time;
		} else {
			const timeParts: string[] = time.split(':');
			return (parseInt(timeParts[0], 10) + 12) % 24 + ':' + timeParts[1];
		}
	}

	private convert24TimeTo12(time24: string): string {
		const blankRegex: RegExp =  /\s+/gmi;
		time24 = time24.replace(blankRegex, '').toLowerCase();
		const timeParts: string[] = time24.split(':');
		const hours: number = parseInt(timeParts[0], 10);
		let amHours: number = hours;
		let postfix: string = 'am';
		if (hours > 12) {
			postfix = 'pm';
			amHours = hours % 12;
		}



		return ((amHours < 10) ? '0' + amHours : amHours) + ':' + ( (timeParts[1].length < 2) ? '0' + timeParts[1] : timeParts[1]) + postfix;
	}

}



// WEBPACK FOOTER //
// ./src/app/settings/settings-employee-edit-history/employee-edit-history-add-modal/employee-edit-history-add-modal.component.ts